import React from "react";
import MaintenanceItemCard from "../../../../Collective/MaintenanceItems/MiniComponents/MaintenanceItemCard";
import UpdateMaintenanceItem from "../../../../Update/UpdateMaintenanceItem/UpdateMaintenanceItem";

export default function MaintanenceItemData({ item }) {
  return (
    <>
      <div className="col-md-4 ps-0 mb-5 position-relative">
        <MaintenanceItemCard item={item} />
      </div>
      <div className="col-md-8">
        <UpdateMaintenanceItem item={item} />
      </div>
    </>
  );
}
